import React, { Component } from 'react';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
//import {Link, Redirect} from 'react-router-dom';
import { Link } from 'react-router-dom';

export class NavMenu extends Component {
    static displayName = NavMenu.name;

    constructor(props) {
        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.state = {
            collapsed: true,
            userType: -1,
            mobileOpen: true
        };
        this.activeRoute = this.activeRoute.bind(this);
        this.handleDrawerToggle = this.handleDrawerToggle(this)
    }

    handleDrawerToggle() {
        console.log(this.state.mobileOpen)
        this.setState({ mobileOpen: !this.state.mobileOpen });
    }

    activeRoute(routeName) {
        return this.props.location.pathname.indexOf(routeName) > -1 ? true : false;
    }

    componentDidMount() {
        this.getUserType();
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed,
        });
    }


    signOut = () => {
        localStorage.removeItem("authtoken");
        window.location.href = "/";
    }

    getUserType = () => {
        let pageData = {
            operation: "GetUserType"
        };

        fetch(global.variables.API_USEROPERATIONS_GETUSERTYPE, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageData)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                this.setState({ userType: result.userType });
            });
    }

    render() {

        const { userType, mobileOpen } = this.state

        return (
            <div>
                <AppBar position="fixed" className="appBar" style={{ zIndex: 999999 }}>
                    <Toolbar style={{ justifyContent: "space-between" }}>
                        <IconButton
                            className="menuButton"
                            color="inherit"
                            aria-label="open menu"
                            edge="start"
                            onClick={() => {
                                console.log(this.state.mobileOpen)
                                this.setState({ mobileOpen: !this.state.mobileOpen });
                            }}
                        >
                            <MenuIcon />
                        </IconButton>
                        <Typography variant="h6" noWrap>
                            <a href="/dashboard">
                                <img src="/images/rom_logo.png" alt="" width="128" height="36" />
                            </a>
                        </Typography>

                        {
                            //<span
                            //    color="#ffffff"
                            //    style={{ justifyContent: "flex-end" }}
                            //    onClick={this.signOut.bind(this)}
                            //>
                        }

                        <a
                            href=""
                            color="#ffffff"
                            style={{
                                justifyContent: "flex-end",
                                color: "#ffffff",
                                textDecoration: "none"
                            }}
                            onClick={this.signOut.bind(this)}
                        >
                            Sign Out
                        </a>

                        {
                            //</span>
                        }

                    </Toolbar>
                </AppBar>
                <Drawer
                    //variant="permanent"
                    className="drawer"
                    variant={window.innerWidth < 769 ? "temporary" : "permanent"}
                    anchor={'left'}
                    open={mobileOpen}
                    onClose={this.handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}>
                    <div className="bosluk" />
                    <List style={{ padding: 10 }}>
                        {
                            //<Link to="/dashboard">
                            //    <ListItem button key="Dashboard">
                            //        <ListItemText primary="Dashboard" />
                            //    </ListItem>
                            //</Link>
                        }
                        <Link to="/projectlist">
                            <ListItem button key="Project List" style={{ display: userType === 2 || userType === 3 || userType === 4 ? "block" : "none" }} selected={this.activeRoute("/projectlist")} >
                                <ListItemText primary="Project List" />
                            </ListItem>
                        </Link>
                        {
                            //<Link to="/listofallprojects">
                            //    <ListItem button key="List of All Projects" style={{ display: userType === 2 || userType == 3 ? "block" : "none" }} >
                            //        <ListItemText primary="List of All Projects" />
                            //    </ListItem>
                            //</Link>
                        }
                        {
                            //<Link to="/missionlist/0">
                            //    <ListItem button key="Mission List">
                            //        <ListItemText primary="Mission List" />
                            //    </ListItem>
                            //</Link>
                        }
                        <Link to="/createproject">
                            <ListItem button key="Create Project" style={{ display: userType === 2 ? "block" : "none" }} selected={this.activeRoute("/createproject")}>
                                <ListItemText primary="Create Project" />
                            </ListItem>
                        </Link>
                        <Link to="/createmission">
                            <ListItem button key="Create Mission" style={{ display: userType === 2 ? "block" : "none" }} selected={this.activeRoute("/createmission")}>
                                <ListItemText primary="Create Mission" />
                            </ListItem>
                        </Link>
                        {
                            //<Link to="/assignmission">
                            //    <ListItem button key="Assign Mission">
                            //        <ListItemText primary="Assign Mission" />
                            //    </ListItem>
                            //</Link>
                        }
                        <Link to="/uploadfile">
                            <ListItem button key="Library" style={{ display: userType === 2 || userType === 3 || userType === 4 ? "block" : "none" }} selected={this.activeRoute("/uploadfile")}>
                                <ListItemText primary="Library" />
                            </ListItem>
                        </Link>
                        <Link to="/searchfilter">
                            <ListItem button key="Search & Report"
                                style={{ display: userType === 2 || userType === 4 ? "block" : "none" }}
                                selected={this.activeRoute("/searchfilter")}
                            >
                                <ListItemText primary="Search & Report" />
                            </ListItem>
                        </Link>
                        <Link to="/thematicreport">
                            <ListItem button key="Segment Report" style={{ display: userType === 2 || userType === 4 ? "block" : "none" }} selected={this.activeRoute("/thematicreport")}>
                                <ListItemText primary="Segment Report" />
                            </ListItem>
                        </Link>
                        <Link to="/users">
                            <ListItem button key="Users" style={{ display: userType === 1 ? "block" : "none" }} selected={this.activeRoute("/users")}>
                                {
                                    //<ListItem button key="Users" style={{ display: userType === 1 || userType === 4 ? "block" : "none" }} >
                                }
                                <ListItemText primary="Users" />
                            </ListItem>
                        </Link>
                        <Link to="/contactlist">
                            <ListItem button key="Contact List" style={{ display: userType === 1 || userType === 2 ? "block" : "none" }} selected={this.activeRoute("/contactlist")}>
                                <ListItemText primary="Contact List" />
                            </ListItem>
                        </Link>
                        <Link to="/beneficiaries">
                            <ListItem button key="Beneficiary List" style={{ display: userType === 1 || userType === 2 ? "block" : "none" }} selected={this.activeRoute("/beneficiaries")}>
                                <ListItemText primary="Beneficiary List" />
                            </ListItem>
                        </Link>
                        <Link to="/changepassword">
                            <ListItem button key="Change Password" style={{ display: userType > -1 ? "block" : "none" }} selected={this.activeRoute("/changepassword")}>
                                <ListItemText primary="Change Password" />
                            </ListItem>
                        </Link>
                        <Link to="/help">
                            <ListItem button key="Help" style={{ display: userType > -1 ? "block" : "none" }} selected={this.activeRoute("/help")}>
                                <ListItemText primary="Help" />
                            </ListItem>
                        </Link>
                        {
                            //<Link to="/entryintervention">
                            //    <ListItem button key="EntryIntervention" style={{ display: userType === 1 ? "block" : "none" }} selected={this.activeRoute("/entryintervention")}>
                            //        <ListItemText primary="Entries" />
                            //    </ListItem>
                            //</Link>
                        }
                        {
                            //<Link to="/createmissionpageauthorized">
                            //    <ListItem button key="Upload Full Cycle" style={{ display: userType === 2 ? "block" : "none" }} >
                            //        <ListItemText primary="Upload Full Cycle" />
                            //    </ListItem>
                            //</Link>
                        }

                        {
                            //<Link to="/">
                            //    <ListItem button key="Reports">
                            //        <ListItemText primary="Reports" />
                            //    </ListItem>
                            //</Link>
                        }

                        {
                            //<Link to="/signin">
                            //    <ListItem button key="Sign-in">
                            //        <ListItemText primary="*Sign-in" />
                            //    </ListItem>
                            //</Link>
                            //<Link to="/cycleofthereport/5">
                            //    <ListItem button key="Cycle Of The Report">
                            //        <ListItemText primary="*Cycle Of The Report" />
                            //    </ListItem>
                            //</Link>
                            //<Link to="/projectdetails/5">
                            //    <ListItem button key="Project & Details">
                            //        <ListItemText primary="*Project & Details" />
                            //    </ListItem>
                            //</Link>
                            //<Link to="/templatefilling/5">
                            //    <ListItem button key="Template Filling">
                            //        <ListItemText primary="*Template Filling" />
                            //    </ListItem>
                            //</Link>
                            //<Link to="/templatemonitoringnotesupply">
                            //    <ListItem button key="TemplateMonitoringNS">
                            //        <ListItemText primary="*TemplateMonitoringNS" />
                            //    </ListItem>
                            //</Link>
                            //<Link to="/templatemonitoringnoteworks">
                            //    <ListItem button key="TemplateMonitoringNW">
                            //        <ListItemText primary="*TemplateMonitoringNW" />
                            //    </ListItem>
                            //</Link>
                            //<Link to="/templatemq">
                            //    <ListItem button key="Template MQ">
                            //        <ListItemText primary="*Template MQ" />
                            //    </ListItem>
                            //</Link>
                            //<Link to="/templatemr">
                            //    <ListItem button key="Template MR">
                            //        <ListItemText primary="*Template MR" />
                            //    </ListItem>
                            //</Link>
                            //<Link to="/templatemonitoringnotesuppliesongoing">
                            //    <ListItem button key="TemplateMonitoringNSO">
                            //        <ListItemText primary="*TemplateMonitoringNSO" />
                            //    </ListItem>
                            //</Link>
                            //<Link to="/templatemonitoringnoteworksongoing">
                            //    <ListItem button key="TemplateMonitoringNWO">
                            //        <ListItemText primary="*TemplateMonitoringNWO" />
                            //    </ListItem>
                            //</Link>
                            //<Link to="/templatemqongoing">
                            //    <ListItem button key="Template MQO">
                            //        <ListItemText primary="*Template MQO" />
                            //    </ListItem>
                            //</Link>
                            //<Link to="/templatemrongoing">
                            //    <ListItem button key="Template MRO">
                            //        <ListItemText primary="*Template MRO" />
                            //    </ListItem>
                            //</Link>
                        }

                    </List>
                </Drawer>
            </div >
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/NavMenu.js